import React from "react";

const SearchChampions = () => {
  return <div>SearchChampions</div>;
};

export default SearchChampions;
